module.exports = __webpack_public_path__ + "img/img-istj.a9c56b0b.jpg";